var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"peoplelist q-px-md q-py-lg"},_vm._l((_vm.people),function(person){return _c('router-link',{key:person.id,staticClass:"person flex items-center",attrs:{"to":{
      name: _vm.to,
      params: { personId: person.id },
    }}},[_c('Avatar',{attrs:{"person":person}}),_c('div',{staticClass:"ellipsis q-ml-md"},[_vm._v(" "+_vm._s(person.firstName)+" "+_vm._s(person.lastName)+" ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }